import { createSelector } from 'selectors'

import { constant } from './constant'

const { selector } = constant

const getElementsWithAffectedScrollSelectors = () =>
	createSelector<NodeListOf<HTMLElement>>({ selector: selector.elementWithAffectedScroll }, true)
export const getShiftTriggerForScrollSelector = (scope: HTMLElement, direction: string) =>
	createSelector<HTMLElement>({ scope, selector: selector.shiftTrigger, value: direction })
export const getScrollToViewElementSelector = (scope: HTMLElement) =>
	createSelector<HTMLElement>({ scope, selector: selector.elementScrollToView })

export const getAllScrolledObjects = () => ({
	elementsWithAffectedScroll: getElementsWithAffectedScrollSelectors(),
})
